export default __webpack_public_path__ + "static/media/cd.588b1447.svg";